import { buildUrl } from "../../../ReusableFunctions/reusableFunctions";
import { SERVER_URLS } from "../../../appConstants";
import { getToken } from "../../authentication";

export const getDrones = (dspId, pageSize, pageNumber) => {
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();
            const url = buildUrl(SERVER_URLS.BACKEND_SERVER + "/bhumeet_team/customerSuccessEngineer/dsp/drones", {
                pageNumber: pageNumber ? pageNumber : undefined,
                pageSize: pageSize ? pageSize : undefined,
                dspId: dspId ? dspId : undefined
            })
            const response = await fetch(url,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            if (response.ok) {
                resolve(data?.drones);
            } else {
                reject(
                    data?.message || "Something went wrong while getting drones."
                );
            }
        } catch (error) {
            reject("Something went wrong while getting drones.");
        }
    });
};

export const getDroneDetails = (droneId) => {
    console.log('droneId:', droneId)
    return new Promise(async (resolve, reject) => {
        try {
            const token = getToken();
            const url = SERVER_URLS.BACKEND_SERVER + `/bhumeet_team/customerSuccessEngineer/dsp/drones/${droneId}`
            const response = await fetch(url,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const data = await response.json();
            console.log('dsta:', data)
            if (response.ok) {
                resolve(data?.drone);
            } else {
                reject(
                    data?.message || "Something went wrong while getting drones."
                );
            }
        } catch (error) {
            reject("Something went wrong while getting drones.");
        }
    });
};